<template>
	<transition :css="false">
		<div
			:id="uniqueId"
			ref="gridLayout"
			:class="[$attrs.class]"
			class="grid-layout"
		>
			<transition name="sidebar-fade">
				<div
					id="left-col"
					v-show="withSidebar"
				>
					<div
						id="left-header"
						class="px-4"
					>
						<slot name="left-header">
							<Title :value="leftTitle" />
						</slot>
					</div>
					<div id="left-content">
						<slot name="left-content"></slot>
					</div>
					<div
						id="left-footer"
						class="px-4"
					>
						<slot name="left-footer">
							<div
								class="w-8/12 h-full flex justify-center items-center gap-3"
							>
								<button
									class="btn btn-fixed-size"
									@click="ClearFilters"
								>
									LIMPAR
								</button>
								<button
									class="btn btn-fixed-size"
									@click="ApplyFilters"
								>
									APLICAR
								</button>
							</div>
						</slot>
					</div>
				</div>
			</transition>
			<div id="right-col">
				<div
					id="right-header"
					class="px-4"
				>
					<slot name="right-header">
						<router-link
							class="btn btn-rounded"
							:to="{ name: 'Home' }"
						>
							<i class="fas fa-arrow-left"></i>
						</router-link>
						<Title :value="rightTitle" />
					</slot>
				</div>
				<div id="right-content">
					<slot name="right-tool-bar">
						<ToolBar>
							<div class="w-full flex gap-8 tool-bar">
								<div class="flex items-center py-1">
									<button
										class="btn btn-tool"
										:class="{
											'has-filters': hasAtLeastOneFilter,
										}"
										@click="ToggleShowSidebar()"
									>
										<i
											class="fa-filter mx-2 font-20"
											:class="
												hasAtLeastOneFilter
													? 'fas'
													: 'far'
											"
										></i>
									</button>
								</div>
								<div
									v-if="showSearchBar"
									class="w-4/12 flex items-center py-1 gap-1"
								>
									<button
										class="btn btn-tool"
										@click="Search()"
									>
										<i
											class="fal fa-search mx-2 font-20"
										></i>
									</button>
									<SearchInput
										class="w-full"
										:search="searchTerm"
										@change="searchTerm = $event"
										@search="Search()"
									/>
								</div>
							</div>
						</ToolBar>
					</slot>
					<slot name="right-content"></slot>
				</div>
				<div
					id="right-footer"
					class="px-4"
				>
					<slot name="right-footer"></slot>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
	import ToolBar from './ToolBar'
	import SearchInput from './SearchInput'
	import { mapActions, mapGetters } from 'vuex'
	import { useGetUniqueId } from '@/composables'

	export default {
		name: 'GridLayoutWithFilters',
		components: {
			ToolBar,
			SearchInput,
		},
		props: {
			leftTitle: {
				type: String,
				default: 'FILTROS',
			},
			rightTitle: {
				type: String,
				default: '',
			},
			showSearchBar: {
				type: Boolean,
				default: true,
			},
			reactiveSidebar: {
				type: Boolean,
				default: true,
			},
			sidebarState: {
				type: Boolean,
				default: true,
			},
		},
		data() {
			return {
				uniqueId: '',
				withSidebar: false,
				hasAtLeastOneFilter: false,
				searchTerm: '',
			}
		},
		computed: {
			...mapGetters('system', ['showSidebar']),
		},
		watch: {
			showSidebar: {
				handler(show) {
					if (!this.reactiveSidebar) return

					this.SidebarHandler(show)
				},
				immediate: true,
			},
			sidebarState: {
				handler(val) {
					this.SidebarHandler(val)
				},
				immediate: true,
			},
		},
		methods: {
			...mapActions('system', ['ToggleShowSidebar']),
			async SidebarHandler(show) {
				await this.$nextTick()

				const grid = document.querySelector(`#${this.uniqueId}`)
				if (!grid) return

				const left = document.querySelector(
					`#${this.uniqueId} #left-col`
				)
				if (!left) return

				this.withSidebar = show

				if (show) {
					grid.classList.add('with-sidebar')
				} else {
					grid.classList.remove('with-sidebar')
				}
			},
			ClearFilters() {
				this.$emit('clear-filters')
			},
			ApplyFilters() {
				this.$emit('apply-filters')
			},
			Search() {
				this.$emit('search', this.searchTerm)
			},
		},
		beforeMount() {
			this.uniqueId = useGetUniqueId('grid')
		},
		async mounted() {
			await this.$nextTick()

			const searchInput = this.$refs.search

			if (this.showSearchBar && searchInput) searchInput.focus()
		},
	}
</script>

<style lang="scss" scoped></style>
